import gql from 'graphql-tag';

export default gql`
mutation changeAppApp(
        $uuid: String!,
        $lang: String,
        $name: String,
        $desc: String
        ) {
    updateApps(input: {
        uuid: $uuid,
        lang: $lang,
        name: $name,
        desc: $desc
    }) {
        uuid
    }
}
`;
